import { render } from "./AboutPart.vue?vue&type=template&id=69431aaa&scoped=true"
import script from "./AboutPart.vue?vue&type=script&lang=js"
export * from "./AboutPart.vue?vue&type=script&lang=js"

import "./AboutPart.vue?vue&type=style&index=0&id=69431aaa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69431aaa"]])

export default __exports__